import { createContext, useReducer } from "react";
import * as types from "./types";

const initialState = {
  primaryQuestionnaire: null,
  loading: false,
  questionnaireList: {},
  questionnaireData: {},
  query: {},
};

const questionnaireReducer = (state, action) => {
  switch (action.type) {
    case types.GET_PRIMARY_QUESTIONNAIRE:
      return {
        ...state,
        primaryQuestionnaire: action.payload,
      };
    case types.GET_QUESTIONNAIRE_LISTING:
      return {
        ...state,
        questionnaireList: action.payload,
      };
    case types.GET_QUESTIONNAIRE_BY_ID:
      return {
        ...state,
        questionnaireData: action.payload,
      };
    case types.SET_QUERY:
      return {
        ...state,
        query: action.payload,
      };
    case types.SET_VIRTUAL_HEIGHT:
      return {
        ...state,
        isVirtualHeightNeeded: action.payload,
      };
    default:
      return state;
  }
};

export const QuestionnaireContext = createContext(initialState);

const QuestionnaireProvider = ({ children }) => {
  const [questionnaireState, questionnaireDispatch] = useReducer(
    questionnaireReducer,
    initialState
  );

  return (
    <QuestionnaireContext.Provider
      value={[questionnaireState, questionnaireDispatch]}
    >
      {children}
    </QuestionnaireContext.Provider>
  );
};

export default QuestionnaireProvider;
